const handleRetainedEarningInputChange = (event: Event): void => {
  if (!(event.target instanceof HTMLInputElement)) {
    return
  }

  if (event.target.value === '') {
    $('.retained-earnings-col').hide()
  } else {
    $('.retained-earnings-col').show()
  }
}

export default (): void => {
  $(document).on(
    'change',
    '[data-behaviour~="mlu-retained-earnings-account"]',
    handleRetainedEarningInputChange
  )
}
